import React, { useEffect } from "react";
import { SwipeableDrawer } from "@material-ui/core";
import { useSideNavState } from "../../../zust.js";
import { XIcon } from "@heroicons/react/outline";
import { AdminNavLinks, NavLinks } from "./NavLinks";
import { HiMenuAlt1 } from "react-icons/hi";
import { Link } from "react-router-dom";

export const AuthNav = ({
  title,
  showLogo = false,
  showMenu = true,
  className = "",
  onMenuClick,
}) => {
  const { sideNavState, setSideNavState } = useSideNavState();

  useEffect(() => {
    setSideNavState(false);
  }, []);

  const handleMenuClick = () => {
    if (onMenuClick) {
      onMenuClick();
    } else {
      setSideNavState(!sideNavState);
    }
  };

  return (
    <div
      className={`
        flex flex-row h-18 z-30 bg-white px-3 fixed py-4 w-full  ${className}
      `}
    >
      <div className="flex-none flex items-center">
        {showMenu && (
          <HiMenuAlt1
            onClick={handleMenuClick}
            className="h-8 cursor-pointer lg:mr-6 text-3xl"
          />
        )}

        {showLogo && (
          <img className="h-8" src={"/img/logo/icon.svg"} alt="Logo" />
        )}
      </div>

      {title && (
        <div className="flex-1 flex items-center justify-center">
          <h1 className="text-lg font-body font-semibold text-gray-800">
            {title}
          </h1>
        </div>
      )}
    </div>
  );
};

export const SignNav = () => {
  const { sideNavState, setSideNavState } = useSideNavState();
  return (
    <div
      className="
   flex  flex-row h-18  z-30 px-2 md:px-8 py-4 w-full  border 
"
    >
      <div className="flex-none w-16 overflow-hidden relative flex">
        <Link to="/" className="w-full">
          <img className="w-40 object-cover" src="/img/new/logo/favicon.svg" />
        </Link>
      </div>
    </div>
  );
};

export const SideNav = () => {
  const { sideNavState, setSideNavState } = useSideNavState();

  useEffect(() => {
    setSideNavState(false);
  }, []);

  return (
    <SwipeableDrawer
      anchor={"left"}
      open={sideNavState}
      onClose={() => setSideNavState(false)}
      onOpen={() => setSideNavState(true)}
      className=""
      ModalProps={{
        // Prevent focus on hidden elements
        keepMounted: false,
      }}
    >
      <div
        className="w-80 min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white"
        role="navigation"
        aria-label="Main navigation"
      >
        {/* Header Section */}
        <div className="p-6 border-b border-slate-700/50">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-xl flex items-center justify-center">
                <img
                  className="h-6 w-6"
                  src={"/img/logo/icon.png"}
                  alt="Logo"
                />
              </div>
              <div>
                <h2 className="font-bold text-lg">FinanceApp</h2>
                <p className="text-xs text-slate-400">Investment Platform</p>
              </div>
            </div>
            <button
              onClick={() => setSideNavState(false)}
              className="p-2 hover:bg-slate-700/50 rounded-lg transition-colors"
              aria-label="Close navigation menu"
              tabIndex={sideNavState ? 0 : -1}
            >
              <XIcon className="h-5 w-5 text-slate-400 hover:text-white" />
            </button>
          </div>
        </div>
        {/* Navigation Section */}
        <div className="flex-1 px-4 py-6">
          <div className="space-y-2">
            <NavLinks />
          </div>
        </div>
      </div>
    </SwipeableDrawer>
  );
};

export const AdminSideNav = () => {
  const { sideNavState, setSideNavState } = useSideNavState();

  return (
    <SwipeableDrawer
      anchor={"left"}
      open={sideNavState}
      onClose={() => setSideNavState(false)}
      onOpen={() => setSideNavState(true)}
      className=""
      ModalProps={{
        // Prevent focus on hidden elements
        keepMounted: false,
      }}
    >
      <div
        className="w-80 h-full bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white"
        role="navigation"
        aria-label="Admin navigation"
      >
        {/* Admin Header Section */}
        <div className="p-6 border-b border-gray-700/50">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div>
                <h2 className="font-bold text-lg">Admin Panel</h2>
                <p className="text-xs text-gray-300">Management Dashboard</p>
              </div>
            </div>
            <button
              onClick={() => setSideNavState(false)}
              className="p-2 hover:bg-gray-700/50 rounded-lg transition-colors duration-200"
              aria-label="Close admin navigation menu"
              tabIndex={sideNavState ? 0 : -1}
            >
              <XIcon className="h-5 w-5 text-gray-300 hover:text-white transition-colors" />
            </button>
          </div>

          {/* Admin Badge */}
          <div className="bg-gradient-to-r from-indigo-600/30 to-purple-600/30 backdrop-blur-sm border border-indigo-500/30 rounded-lg p-3">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-gray-100">
                Administrator Access
              </span>
            </div>
          </div>
        </div>

        {/* Admin Navigation Section */}
        <div className="flex-1 px-4 py-6">
          <div className="space-y-2">
            <AdminNavLinks />
          </div>
        </div>

        {/* Admin Footer */}
        <div className="p-4 border-t border-gray-700/50">
          <div className="text-xs text-gray-300 text-center">
            <p>Admin Dashboard v2.0</p>
            <p className="mt-1 opacity-75">Secure Management Portal</p>
          </div>
        </div>
      </div>
    </SwipeableDrawer>
  );
};
